import {
  type ComponentPropsWithoutRef,
} from "react";

import { PackageOpenIcon } from "lucide-react";

import { PrimSheet } from "@/shared-web.ui/prim.sheet";
import { Flex } from "@/shared-web.ui/ui.flex";
import { IconBadge } from "@/shared-web.ui/ui.icon-badge";
import { IconButton } from "@/shared-web.ui/ui.icon-button";
import { useGetCart } from "@/stf.data/hook.cart";

import { CartRoot } from "./cart.root.feat";
import { CartBody } from "./cart-body.feat";
import { CartError } from "./cart-error.feat";
import { CartFooter } from "./cart-footer.feat";
import { CartHeader } from "./cart-header.feat";
import { CartOverlay } from "./cart-overlay.feat";

interface CartIconProps extends ComponentPropsWithoutRef<typeof PackageOpenIcon> {}
const CartIcon = (props: CartIconProps) => {
  return (
    <PackageOpenIcon
      strokeWidth={1}
      {...props}
    />
  );
};

interface CartButtonProps extends Pick<ComponentPropsWithoutRef<typeof IconButton>, "onClick"> {}
const CartButton = (props: CartButtonProps) => {
  const { data } = useGetCart();

  return (
    <IconButton
      className="text-inherit"
      radius="full"
      variant="ghost"
      screenReaders="Open cart"
      {...props}
    >
      <IconBadge badgeContent={data?.itemList.length || 0}>
        <CartIcon />
      </IconBadge>
    </IconButton>
  );
};

const CartModules = () => {
  return (
    <CartRoot>
      <Flex
        direction="column"
        className="relative size-full bg-accent-1"
      >
        <CartOverlay />
        <CartHeader
          className="rounded-b-2 shadow-3"
        />
        <Flex
          className="relative"
          flexGrow="1"
          my="3"
        >
          <CartBody />
        </Flex>
        <CartError />
        <CartFooter
          className="rounded-t-2 shadow-3"
        />
      </Flex>
    </CartRoot>
  );
};

interface CartProps extends ComponentPropsWithoutRef<typeof PrimSheet.Root> {}
const Cart = (props: CartProps) => {
  return (
    <PrimSheet.Root {...props}>
      <PrimSheet.Title hidden>My Cart</PrimSheet.Title>
      <PrimSheet.Content
        side="right"
        className="w-screen max-w-[480px] p-0"
      >
        <CartModules />
      </PrimSheet.Content>
    </PrimSheet.Root>
  );
};

export { Cart, CartButton, CartIcon, CartModules };
